import React, {useState, useEffect} from "react";
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import DeviceErrorUpdateForm from "./DeviceErrorUpdateForm";
import { SIREN_CONFIG } from 'config.js';
import moment from 'moment';
import {useSelector} from 'react-redux';



const DeviceErrorUpdate = (props) => {

  const {className, match, history, ...rest } = props;
  const classes = useStyles();

  const [onErrorDeviceInfo, setOnErrorDeviceInfo] = useState(null);
  const facility_id = useSelector((store) => store.user.facility_id);

  const loadData = (rowId) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/device/onErrorDeviceInfo?facility_id=${facility_id}&rowId=${rowId}`;

    fetch(url)
    .then(res => res.json())
    .then(snapshot => {
      // console.log("snapshot: ", snapshot);

      //default is now
      let a_timestamp = '';
      try{
        if ( snapshot.resultData[0].action_timestamp !== null && snapshot.resultData[0].action_timestamp !== ''){
          a_timestamp = moment(snapshot.resultData[0].action_timestamp).format('YY.MM.DD HH:mm');
        } else {
          a_timestamp = moment().format('YY.MM.DD HH:mm');
        }

      } catch(e){
        a_timestamp = moment().format('YY.MM.DD HH:mm');
      }

      // console.log("a_timestamp : " + a_timestamp);

      var onErrorDevice = {
        rowId : snapshot.resultData[0].rowId,
        deviceId: snapshot.resultData[0].deviceId,
        errorTime: snapshot.resultData[0].errorTime,
        roomName: snapshot.resultData[0].roomName,
        installed_pos_detail: snapshot.resultData[0].installed_pos_detail,
        action_taken : snapshot.resultData[0].action_taken !== null ? snapshot.resultData[0].action_taken : '',
        action_user : snapshot.resultData[0].action_user !== null ? snapshot.resultData[0].action_user : '',
        action_timestamp : a_timestamp
      };

      setOnErrorDeviceInfo(onErrorDevice);
    }
    );
  }


  useEffect( () => {

    loadData(match.params.rowId);
  }, []);


  return (
    <div className={classes.root}>
      <div className={classes.content}>
        { onErrorDeviceInfo && <DeviceErrorUpdateForm onErrorDeviceInfo={onErrorDeviceInfo} history={history} /> }
      </div>
    </div>
  );
};


DeviceErrorUpdate.propTypes = {
  history: PropTypes.object
};

export default withRouter(DeviceErrorUpdate);


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));